/**
 * Handles the black loading bars between
 * page transitions
 */

export default class PageLoader {

    constructor() {
        this.loader = $(".page-loader");
        this.animationDuration = 1050;
        this.isAnimating = true;
        this.loaderText = $('.page-loader .page-loader-text');

        // Reveal the page on load
        this.initialReveal();
    }

    /**
     * Initial page reveal once everything is loaded
     */
    initialReveal() {
        let t = this;
        $('body').find('*').imagesLoaded({background:true}, function() {
            setTimeout(function() {
                t.close();
                window.App.reInitialize();
                window.App.started = true;
                t.isAnimating = false;
            }, t.animationDuration);
        });
    }

    /**
     * Animate in the loader columns
     * @param link - URL
     * @param title - Title of page
     */
    show(title) {
        this.isAnimating = true;
        this.loaderText.text(title);
        this.loader.removeClass('close').addClass('open');
        window.MobileNav.closeSecondary();
        setTimeout(() => {
            $("body").addClass('loading');
        }, this.animationDuration);
    }

    /**
     * Animate out the columns
     */
    close() {
        // Set the windows scroll position to the top
        $(window).scrollTop(0);
        
        // Re-Initialize everything from all other pages
        if (window.App.started) {
            window.App.reInitialize();
        }

        // Close the loader bars
        this.loader.addClass('close');

        // Start animations a sooner than
        // when the page loader is fully out
        setTimeout(() => {
            $('body').removeClass('loading');
        }, this.animationDuration / 3);
        // Reset the loader
        setTimeout(() => {
            this.loader.removeClass('open').removeClass('close');
            this.isAnimating = false;
        }, this.animationDuration);
    }

}


// WEBPACK FOOTER //
// ./public/js/PageLoader.js